<template>
    <div v-if="msgAlerta" class="info-alert row-space">{{ msgAlerta }}</div>

    <div class="menu-acesso-page">
        <div class="menu-acesso-body">

            <div v-for="grupo in menusTree" :key="grupo.id" class="menu-card">
                <div class="menu-card-header">
                    <label class="check-line check-line--grupo">
                        <input
                            class="menu-check"
                            type="checkbox"
                            :checked="grupo.perfil_ativo === 'S'"
                            @change="toggleGrupo(grupo)"
                        />
                        <span class="check-custom"></span>
                        <span class="menu-card-title">{{ grupo.titulo_menu }}</span>
                    </label>
                </div>

                <div class="menu-card-content">
                    <label
                        v-for="item in grupo.filhos"
                        :key="item.id"
                        class="check-line check-line--item"
                    >
                        <input
                            class="menu-check"
                            type="checkbox"
                            :checked="item.perfil_ativo === 'S'"
                            @change="toggleItem(item)"
                        />
                        <span class="check-custom"></span>
                        <span class="menu-item-text">{{ item.titulo_menu }}</span>
                    </label>
                </div>
            </div>

            <div v-if="itensRaiz.length" class="menu-card">
                <div class="menu-card-header">
                    <div class="menu-card-title">Acessos Avulsos</div>
                </div>

                <div class="menu-card-content">
                    <label
                        v-for="item in itensRaiz"
                        :key="item.id"
                        class="check-line check-line--item"
                    >
                        <input
                            class="menu-check"
                            type="checkbox"
                            :checked="item.perfil_ativo === 'S'"
                            @change="toggleItem(item)"
                        />
                        <span class="check-custom"></span>
                        <span class="menu-item-text">{{ item.titulo_menu }}</span>
                    </label>
                </div>
            </div>

        </div>

        <div class="menu-acesso-footer">
            <div class="row-end">
                <button type="button" class="btn-confirm" @click="salvar">Salvar Alterações</button>
                <button type="button" class="btn-cancel" @click="closePage">Cancelar</button>
            </div>
        </div>
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { Api } from '@/funcoes/apiExport'
import { globalStore } from '@/globals';

const emit = defineEmits(['close'])
const props = defineProps({idPerfil: {type: Number, default: 0}});

const listaMenus = ref([]);
const menusTree = ref([])
const msgAlerta = ref(null);
const itensRaiz = ref([])
const alteracoes = ref(new Map())


function closePage(){emit('close');}

async function lerDados() {
    try{
        msgAlerta.value = null;
        const req = await Api.genericPost('/listas/sys/menus', {idreferencia: props.idPerfil});
        listaMenus.value = req;
        montarTree();
    } catch (error){msgAlerta.value = `ATENÇÃO: Não foi possível acessar dados do servidor: "${error.message}"`;}
}


function montarTree() {
    const grupos = listaMenus.value
        .filter(m => m.tipo === 'GRUPO')
        .sort((a,b) => a.ordem - b.ordem)

    const itens = listaMenus.value
        .filter(m => m.tipo === 'ITEM')
        .sort((a,b) => a.ordem - b.ordem)

    menusTree.value = grupos.map(g => ({
        ...g,
        filhos: itens.filter(i => i.idmenu_pai === g.id)
    }))

    itensRaiz.value = itens.filter(i => !i.idmenu_pai)
}


const toggleItem = (item) => {
    item.perfil_ativo = item.perfil_ativo === 'S' ? 'N' : 'S'
    alteracoes.value.set(item.id, item.perfil_ativo)
}


const toggleGrupo = (grupo) => {
    const novo = grupo.perfil_ativo === 'S' ? 'N' : 'S';
    grupo.perfil_ativo = novo;
    alteracoes.value.set(grupo.id, novo);

     grupo.filhos.forEach(item => {
        item.perfil_ativo = novo;
        alteracoes.value.set(item.id, novo);
    });
}


async function salvar() {
    msgAlerta.value = null;
    const menus = Array.from(alteracoes.value).map(([id, status]) => ({
        id,
        perfil_ativo: status
    }));

    if (menus.length === 0) {
        msgAlerta.value = 'Nenhuma alteração realizada';
        return;
    }

    const payload = {
        idperfil: props.idPerfil,
        idlogin: globalStore.idlogin,
        menus
    }

    try {
        const resp = await Api.genericPost('/cad/perfil/menus', payload);
        if (resp.bolok === 1){
            closePage();
        }else{
            msgAlerta.value = resp?.mensagem || 'Erro ao salvar alterações';
        }
    } catch (error) {
        msgAlerta.value = `Erro ao salvar: ${error.message}`;
    }
}

onMounted(lerDados)
</script>


<style scoped>
.menu-acesso-page {
    border: 2px solid #cfd8dc;
    border-radius: 8px;
    background: #f8fafb;
    overflow: hidden;
}

.menu-acesso-body {
    padding: 12px;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.menu-card {
    background: #ffffff;
    border: 1px solid #d9e2e7;
    border-radius: 8px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
    overflow: hidden;
}

.menu-card-header {
    background: linear-gradient(to bottom, #eef4f6, #e4edf1);
    border-bottom: 1px solid #d9e2e7;
    padding: 10px 12px;
}

.menu-card-title {
    font-size: 15px;
    font-weight: 700;
    color: #31424c;
}

.menu-card-content {
    padding: 10px 12px;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
    gap: 8px 14px;
}

.check-line {
    position: relative;
    display: flex;
    align-items: center;
    gap: 10px;
    min-height: 36px;
    padding: 6px 8px;
    border-radius: 6px;
    cursor: pointer;
    user-select: none;
    transition: background-color 0.15s ease, border-color 0.15s ease;
    border: 1px solid transparent;
}

.check-line:hover {
    background: #f5f9fb;
    border-color: #d8e5ea;
}

.check-line--grupo {
    padding: 0;
    min-height: auto;
    border: none;
    background: transparent;
}

.check-line--grupo:hover {
    background: transparent;
    border-color: transparent;
}

.menu-item-text {
    color: #33424c;
    line-height: 1.2;
}

/* esconde checkbox nativo */
.menu-check {
    position: absolute;
    opacity: 0;
    pointer-events: none;
}

/* checkbox visual */
.check-custom {
    width: 18px;
    height: 18px;
    min-width: 18px;
    border: 1px solid #8aa1ad;
    border-radius: 4px;
    background: #fff;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    transition: all 0.15s ease;
}

.menu-check:checked + .check-custom {
    background: #4a827c;
    border-color: #4a827c;
}

.menu-check:checked + .check-custom::after {
    content: "";
    width: 8px;
    height: 4px;
    border-left: 2px solid #fff;
    border-bottom: 2px solid #fff;
    transform: rotate(-45deg) translateY(-1px);
}

.menu-check:focus + .check-custom {
    box-shadow: 0 0 0 3px rgba(74, 130, 124, 0.18);
}

.menu-acesso-footer {
    display: flex;
    justify-content: flex-end;
    padding: 10px 12px;
    border-top: 1px solid #d9e2e7;
    background: #eef4f6;
}

@media (max-width: 700px) {
    .menu-card-content {
        grid-template-columns: 1fr;
    }

    .menu-acesso-footer {
        justify-content: stretch;
    }

    .btn-salvar-menu {
        width: 100%;
    }
}
</style>